
import { Component, Prop, Vue } from 'vue-property-decorator';

const COLORS = ['#C76715', '#F59940', '#F37F1B', '#FDBE81', '#FFEAD5'];

@Component
export default class Confetti extends Vue {
  @Prop({ default: 100 }) confettiCount!: number;

  colors: string[] = COLORS;

  getConfettiStyle() {
    const color = this.colors[Math.floor(Math.random() * this.colors.length)];
    const left = `${Math.random() * 100}vw`;
    const animationDuration = `${Math.random() * 8 + 4}s`;
    const size = `${Math.random() * 10 + 5}px`;

    return {
      backgroundColor: color,
      left,
      animationDuration,
      width: size,
      height: size
    };
  }
}
